import { useApiQuery } from '@BUP/hooks/useApiQuery'

export const useGetCurrent = (
  resourceName,
  version = 2,
  options = {}
) => {
  const query = useApiQuery(
    ['current', resourceName, version],
    'schools',
    `/${resourceName}`,
    options,
    { authenticated: true, version }
  )

  return {
    isLoadingCurrent: query.isLoading,
    isFetchingCurrent: query.isFetching,
    currentData: query.data ?? [],
    errorCurrent: query.isError ? query.error : null,
    getCurrent: query.refetch
  }
}
